import countries from 'i18n-iso-countries';
import huLocale from 'i18n-iso-countries/langs/hu.json';
import enLocale from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(huLocale);
countries.registerLocale(enLocale);

export type RegionOption = { code: string; label: string };

/** ISO 3166-1 alpha-2 options with Hungarian labels (fallback EN). */
export function getRegionOptions(locale: 'hu' | 'en' = 'hu'): RegionOption[] {
  const names = countries.getNames(locale, { select: 'official' });
  return Object.entries(names)
    .map(([code, label]) => ({ code, label: `${label} (${code})` }))
    .sort((a, b) => a.label.localeCompare(b.label, locale));
}

export function getRegionLabel(code: string | null | undefined, locale: 'hu' | 'en' = 'hu'): string {
  if (!code) return '';
  const upper = code.trim().toUpperCase();
  if (upper.length === 2 && countries.isValid(upper)) {
    const name = countries.getName(upper, locale) || countries.getName(upper, 'en');
    return name ? `${name} (${upper})` : upper;
  }
  return code;
}

/** Normalize free-text / legacy region to ISO alpha-2 when possible. */
export function normalizeRegionCode(value: string | null | undefined): string | null {
  if (!value?.trim()) return null;
  const trimmed = value.trim();
  if (trimmed.length === 2 && countries.isValid(trimmed.toUpperCase())) {
    return trimmed.toUpperCase();
  }
  const byName =
    countries.getAlpha2Code(trimmed, 'hu') ||
    countries.getAlpha2Code(trimmed, 'en');
  return byName || null;
}
